/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import ggRouter from 'ggApp/modules/router';
import {
    LayoutComponent_Checkout_Header as LayoutComponentCheckoutHeader,
    LayoutComponent_LocalLoader as LayoutComponentLocalLoader,
    LayoutComponent_Checkout_Footer as LayoutComponentCheckoutFooter,
} from 'ggApp/modules/layout';
import ggOrder from 'ggApp/modules/order';
import ggTranslator from 'ggApp/modules/translator';
import { translate } from 'ggApp/modules/translator/selectors';
import ggStore from 'ggApp/modules/store';
import { isPartnerStore as isActiveStorePartnerSelector } from 'ggApp/modules/store/selectors';
import CriteoDataLayerReporter from 'ggApp/modules/criteo/components/criteoDataLayerReporter';
import criteoEventType from 'ggApp/modules/criteo/eventTypes';

import EmptyCart from 'ggApp/shared/components/EmptyCartPage/EmptyCart';
import MetaTagsContainer from 'ggApp/shared/containers/metaTags';
import { STORE_TYPE } from 'ggApp/modules/store/constants';
import BusinessRedirectionModal from 'ggApp/shared/modals/BusinessRedirection';
import { checkStoreAndUserType as checkStoreAndUserTypeAction } from 'ggApp/modules/auth/actions';

import './index.scss';

@connect(
    createStructuredSelector({
        order: ggOrder.selectors.orderActive,
        orderFetching: ggOrder.selectors.fetching,
        translations: ggTranslator.selectors.keys,
        storeActive: ggStore.selectors.storeActive,
        isPartnerStore: isActiveStorePartnerSelector,
    }),
    (dispatch) => ({
        rotuerActions: bindActionCreators(ggRouter.actions, dispatch),
        orderActions: bindActionCreators(ggOrder.actions, dispatch),
        checkStoreAndUserType: bindActionCreators(checkStoreAndUserTypeAction, dispatch),
    }),
)
export default class CheckoutCartWrap extends Component {
    componentWillMount() {
        const { orderActions } = this.props;
        const { order, orderFetching } = this.props;

        if (!order.id && !orderFetching) {
            orderActions.getOrder();
        }
    }

    componentDidMount() {
        const { checkStoreAndUserType } = this.props;
        checkStoreAndUserType();
    }

    render() {
        const {
            order,
            orderFetching,
            children,
            translations,
            storeActive,
            isPartnerStore,
        } = this.props;
        const metaPageInfo = {
            title: translate(translations, storeActive.activeLanguage, 'CART_META_TITLE'),
            ...(storeActive.store_type === STORE_TYPE.GROVER_PAY && { robots: 'noindex' }),
        };
        return (
            <section className="cartWrap">
                <MetaTagsContainer metaTags={metaPageInfo} />
                <CriteoDataLayerReporter type={criteoEventType.cart} />
                <LayoutComponentCheckoutHeader />
                <div className="cartWrap__content">
                    <LayoutComponentLocalLoader active={!order.id && orderFetching}>
                        {!order.id || (order.items || []).length === 0 ? (
                            <EmptyCart withBackToHomeLink={!isPartnerStore} />
                        ) : (
                            children
                        )}
                    </LayoutComponentLocalLoader>
                </div>
                <LayoutComponentCheckoutFooter />
                <BusinessRedirectionModal />
            </section>
        );
    }
}
